import * as yup from 'yup';

export const activationDigitsSchema = yup.object().shape({
  activationDigits: yup
    .string()
    .required()
    .matches(/^\d{6}$/, 'otp.modal.invalidOTP'),
});
